<template>
  <Spin fix v-if="loading" class="my-loading-wrap">
    <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
    <div class="msg">{{msg || '加载中，请稍后...'}}</div>
  </Spin>
</template>

<script>
  export default {
    props: [
      'msg'
    ],
    data () {
      return {
        loading: false
      };
    },
    methods: {
      show () {
        this.loading = true;
      },
      hide () {
        setTimeout(() => {
          this.loading = false;
        }, 400);
      }
    }
  };
</script>

<style lang="scss">
  .ivu-spin-fix{
    position: fixed;
    z-index: 999999;
  }
  .my-loading-wrap {
    width: 100%;
    height: 100%;
    .msg {
      margin-top: 6px;
    }

    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }

    @keyframes ani-demo-spin {
      from {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(180deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

  }
</style>


// WEBPACK FOOTER //
// src/components/MyLoading.vue